export default __webpack_public_path__ + "static/media/auction_house.5abc814b.jpg";